/*
>> Theme constant containing theme specs
*/

const currentYear = new Date().getFullYear();

export const brightsuiteTheme = {
  // colors
  navbarBgColor: "bg-white",
  navbarTextColor: "text-[#494e52]",
  navbarTextHoverColor: "hover:text-[#053f9a]",
  footerBgColor: "bg-[#f8f8f8]",
  footerTextColor: "text-[#666666]",
  secondaryNavMenuItemBgColor: "bg-white",
  secondaryNavActiveMenuItem: "border-2 border-[#0d72ce]",
  buttonBgColor: "bg-[#0d72ce]",
  buttonHoverBgColor: "hover:bg-[#053f9a]",
  redirectingTextColor: "text-gray-700",
  redirectingBorder: "border border-b-4 border-b-[#0d72ce]",
  // file path
  logo: "/Brightsuite/brightsuite_logo.png",
  footerLogo: "/Brightsuite/brightsuite_logo.png",
  title: "BrightSuite",
  favicon: "/Brightsuite/favicon.png",
  copyrightText: `&copy; ${currentYear} BrightSuite`,
};

let COGNITO_DOMAIN = "";
let COGNITO_REDIRECTSIGNIN = "";
let COGNITO_REDIRECTSIGNOUT = "";
let COGNITO_REDIRECT_URI = "";
let COGNITO_REGION = "";
let SHOP_URL = "";
let MARKETING_URL = "";
let ACCOUNT_URL = "";
let COOKIE_STORAGE_DOMAIN = "";
let ACCOUNT_API_URL = "";
let COGNITO_APP_CLIENT_ID = "";
let COGNITO_USER_POOL_ID = "";

if (process.env.REACT_APP_MODE === "local") {
  COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
  COGNITO_REDIRECTSIGNIN = process.env.REACT_APP_COGNITO_REDIRECTSIGNIN;
  COGNITO_REDIRECTSIGNOUT = process.env.REACT_APP_COGNITO_REDIRECTSIGNOUT;
  COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI;
  COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
  SHOP_URL = process.env.REACT_APP_SHOP_URL;
  MARKETING_URL = process.env.REACT_APP_MARKETING_URL;
  ACCOUNT_URL = process.env.REACT_APP_ACCOUNT_URL;
  COOKIE_STORAGE_DOMAIN = process.env.REACT_APP_COOKIE_STORAGE_DOMAIN;
  ACCOUNT_API_URL = process.env.REACT_APP_ACCOUNT_API_URL;
  COGNITO_APP_CLIENT_ID = process.env.REACT_APP_COGNITO_APP_CLIENT_ID;
  COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
} else if (process.env.REACT_APP_MODE === "brightsuite-dev") {
  COGNITO_DOMAIN =
    "brightsuite-ecommweb-430666279062.auth.us-east-2.amazoncognito.com";
  COGNITO_REDIRECTSIGNIN = "https://account-dev.brightsuite.com/redirecting";
  COGNITO_REDIRECTSIGNOUT = "https://account-dev.brightsuite.com";
  COGNITO_REDIRECT_URI = "https://account-dev.brightsuite.com/redirecting";
  COGNITO_REGION = "us-east-2";
  SHOP_URL = "https://shop-dev.brightsuite.com";
  MARKETING_URL = "https://brightsuite.com";
  ACCOUNT_URL = "https://account-dev.brightsuite.com";
  COOKIE_STORAGE_DOMAIN = "brightsuite.com";
  ACCOUNT_API_URL = "https://lxsz2lj3td.execute-api.us-east-2.amazonaws.com/v1";
  COGNITO_APP_CLIENT_ID = "57031n1e8up8flesq8r1783cdv";
  COGNITO_USER_POOL_ID = "us-east-2_HpekXXgro";
} else if (process.env.REACT_APP_MODE === "brightsuite-prod") {
  COGNITO_DOMAIN =
    "brightsuite-ecommweb-832527406606.auth.us-east-2.amazoncognito.com";
  COGNITO_REDIRECTSIGNIN = "https://account.brightsuite.com/redirecting";
  COGNITO_REDIRECTSIGNOUT = "https://account.brightsuite.com";
  COGNITO_REDIRECT_URI = "https://account.brightsuite.com/redirecting";
  COGNITO_REGION = "us-east-2";
  SHOP_URL = "https://shop.brightsuite.com";
  MARKETING_URL = "https://brightsuite.com";
  ACCOUNT_URL = "https://account.brightsuite.com";
  COOKIE_STORAGE_DOMAIN = "brightsuite.com";
  ACCOUNT_API_URL = "https://jh9w7x6leb.execute-api.us-east-2.amazonaws.com/v1";
  COGNITO_APP_CLIENT_ID = "5ahg82h37eig472a6rjghokttt";
  COGNITO_USER_POOL_ID = "us-east-2_JXjoLmdK2";
}

export const brightsuiteConstants = {
  ACCOUNT_API_URL,
  COGNITO_APP_CLIENT_ID,
  COGNITO_USER_POOL_ID,
  COGNITO_DOMAIN: COGNITO_DOMAIN,
  COGNITO_REDIRECTSIGNIN: COGNITO_REDIRECTSIGNIN,
  COGNITO_REDIRECTSIGNOUT: COGNITO_REDIRECTSIGNOUT,
  COGNITO_REDIRECT_URI: COGNITO_REDIRECT_URI,
  COGNITO_REGION: COGNITO_REGION,
  SHOP_URL: SHOP_URL,
  MARKETING_URL: MARKETING_URL,
  ACCOUNT_URL: ACCOUNT_URL,
  TERMS_AND_CONDITIONS_URL: `${MARKETING_URL}/terms-and-conditions`,
  PRIVACY_POLICY_URL: `${MARKETING_URL}/privacy-policy`,
  COOKIE_STORAGE_DOMAIN: COOKIE_STORAGE_DOMAIN,
  COOKIE_STORAGE_PATH: "/",
  COOKIE_STORAGE_EXPIRES: 7,
  COOKIE_STORAGE_SECURE: false,
  COOKIE_MAX_AGE: 2592000,
};

export default {
  brightsuiteTheme,
  brightsuiteConstants,
};
